
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'Empty',

  props: {
    size: {
      type: String,
      default: 'lg',
      validator: prop => ['md', 'lg'].includes(prop)
    },

    icon: {
      type: Object,
      default: () => faInfoCircle
    },

    iconSizeOverride: {
      type: String,
      default: undefined
    },

    title: {
      type: String,
      default: () => 'No data yet'
    },

    body: {
      type: String,
      default: null
    }
  }
}
